import { Box, Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import Button from '@/components/button'
import { ShareProjectModal } from '@/components/share-project-modal'
import { useCompanies } from '@/hooks/use-companies'
import { useProject } from '@/pages/projects-form/contexts/project-context'
import { routes } from '@/routes/config'

import { useStyles } from './styles'

export function ThirdStep() {
  const classes = useStyles()
  const [openShareUnitModal, setOpenShareUnitModal] = useState(false)

  const { permissions } = useCompanies()
  const location = useLocation()

  const {
    form: { getValues },
    context: { projectId, isPrivateProject },
  } = useProject()

  const projectName = getValues('project_name')

  const project = projectId
    ? { id: projectId, name: projectName, private: isPrivateProject! }
    : null

  return (
    <>
      <section className={classes.firstSection}>
        <div>
          <CheckCircleIcon />
          <Typography variant='h1'>Cadastro finalizado</Typography>
        </div>
      </section>
      <section className={classes.buttonContainer}>
        <Box display='flex' gridGap='1.3rem'>
          {!permissions.WeedAccess && (
            <Button
              disabled={!permissions?.shareUnit}
              outlined
              onClick={() => setOpenShareUnitModal(true)}
            >
              Compartilhar projeto
            </Button>
          )}
          <Button
            component={Link}
            to={location.state?.from || routes.Projects()}
          >
            Ok, finalizar
          </Button>
        </Box>
      </section>

      <ShareProjectModal
        open={openShareUnitModal}
        onClose={() => setOpenShareUnitModal(false)}
        project={project}
      />
    </>
  )
}
